import React from "react";
import debounce from "debounce";

import { Alert, Button, Col, Icon, Input, message, Popover, Row, Table } from "antd";

import {
    _getOrderStatus,
    _postUpdateProductOrderStatusQty
} from "../../services";

class EditLineItemButton extends React.Component {

    constructor(props) {
        super(props);

        if( !this.props.onConfirm ){
            throw "this.props.onConfirm is required!";
        }

        this.onChangeFinalQty = debounce( this.onChangeFinalQty, 300 );

        this.state = {

            // flags
            loading: true,
            popoverVisible: false,


            // data
            orderStatus: false,
            updateQtyInstructions: []
        }
    }

    componentDidMount() {

        _getOrderStatus({ cartId: this.props.cartId })
            .then(res => {

                this.setState({
                    loading: false,
                    orderStatus: res.data.orderStatus,
                }, () => {
                    
                    this.setState({
                        updateQtyInstructions: this.getSelectedProductOrderStatus().map( productOrderStatus => {

                            return {
                                productOrderStatusId: productOrderStatus._id,
                                qty: false
                            }
            
                        })    
                    })

                });

            })
            .catch(e => {

                message.error(e.toString())
                console.log(e);

            })

    }

    render() {

        return (
            <Popover
                title="Customer Request Cancel Item"
                visible={this.state.popoverVisible}
                content={(
                    <div>
                        <Alert message="This action is not reversible" type="warning" showIcon />
                        {this.renderPopoverTable()}
                        {this.renderPopoverButtons()}
                    </div>
                )}
                trigger="click">

                <Button
                    onClick={() => this.setPopoverVisibility(true)}
                    disabled={this.getPopoverButtonIsDisabled()}
                    type="danger">
                    Customer Request Cancel Item
                </Button>

            </Popover>
        );

    }

    renderPopoverButtons = () => {
        return (
            <Row gutter={8} justify="end" type="flex">
                <Col>
                    <Button
                        type="ghost"
                        onClick={() => this.setPopoverVisibility(false)}
                    >Cancel</Button>
                </Col>
                <Col>
                    <Button
                        loading={this.state.loading}
                        disabled={this.getConfirmButtonIsDisabled()}
                        type="danger"
                        onClick={() => this.onClickConfirmButton()}
                    >Confirm (I understand this is not reversible)</Button>
                </Col>
            </Row>
        );
    }

    renderPopoverTable = () => {

        return (
            <Table
                loading={this.state.loading}
                pagination={false}
                columns={this.getTableColumns()}
                dataSource={this.getSelectedProductOrderStatus()}
            />
        )


    }

    getConfirmButtonIsDisabled = () => {

        let countOfProductsWithQtyFinalised = this.state.updateQtyInstructions.filter(_instruction => {

            if (_instruction.qty === false) {
                return false;
            }

            return true;

        }).length;

        let countOfSelectedProductOrderIds = this.props.productOrderIds.length;

        if (countOfProductsWithQtyFinalised !== countOfSelectedProductOrderIds) {
            return true;
        }

        return false;

    }

    getSelectedProductOrderStatus = () => {

        let productOrderStatuses = this.state.orderStatus && this.state.orderStatus.productOrderStatus || [];

        let productOrderIdsSelected = this.props.productOrderIds.reduce((acc, cur) => {

            acc[cur] = true;
            return acc;

        }, {})

        let itemsSelected = productOrderStatuses.filter(_productOrderStatus => {

            return productOrderIdsSelected[_productOrderStatus.productOrderId];

        });

        return itemsSelected;

    }

    getPopoverButtonIsDisabled = () => {
        return this.props.productOrderIds.length === 0;
    }

    getTableColumns = () => {

        return [
            {
                title: "Title",
                key: "title",
                render: (text, productOrderStatus, index) => {
                    return productOrderStatus.productTitle;
                }
            },

            {
                title: "Current",
                key: "currentQty",
                align: "center",
                render: (text, productOrderStatus, index) => {
                    return productOrderStatus.quantityAvailable;
                }
            },

            {
                title: "to",
                key: "toColumn",
                align: "center",
                render: (text, productOrderStatus, index) => {
                    return "to";
                }
            },

            {
                title: "final",
                key: "finalQty",
                render: (text, productOrderStatus, index) => {

                    return (
                        <Input
                            onChange={e => this.onChangeFinalQty(productOrderStatus, e.target.value)}
                            min={0}
                            max={productOrderStatus.quantityAvailable - 1}
                            style={{ width: "100px" }}
                            type="number"
                            placeholder={productOrderStatus.quantityAvailable - 1} />
                    )
                }
            }

        ];

    }

    onChangeFinalQty = (productOrderStatus, finalQty) => {

        let productOrderStatusId = productOrderStatus._id,
            currentQty = productOrderStatus.quantityAvailable;

        let _tmpFinalQty = parseInt(finalQty);

        if( finalQty < 0 ){
            _tmpFinalQty = false;
            message.error("Qty cannot be a negative value");
        }

        if( finalQty >= currentQty ){
            _tmpFinalQty = false;
            message.error(`Qty must be <= ${currentQty-1}`);
        }

        if( !finalQty ){
            _tmpFinalQty = false;
            message.error("Qty cannot be blank");
        }

        this.setState({
            updateQtyInstructions: this.state.updateQtyInstructions.map(
                _instruction => {

                    if (_instruction.productOrderStatusId !== productOrderStatusId) {
                        return _instruction;
                    }

                    return {
                        ..._instruction,
                        qty: _tmpFinalQty
                    };
                }
            )
        })

    }

    onClickConfirmButton = () => {

        const { updateQtyInstructions, orderStatus } = this.state;
        const orderStatusId = orderStatus._id;

        this.setState({ loading: true });

        _postUpdateProductOrderStatusQty( orderStatusId, updateQtyInstructions)
            .then(res => {

                const { orderStatus } = res.data;

                message.success( "Line Items Edited" );

                this.setPopoverVisibility( false );
                this.props.onConfirm( orderStatus );

            })
            .catch(e => {
                message.error(e.toString());
            })

    }

    setPopoverVisibility = (popoverVisible) => {

        if (popoverVisible) {
            this.setState({
                popoverVisible: true
            })
        }

        if (!popoverVisible) {
            this.setState({
                popoverVisible: false
            })
        }

    }

}

export default EditLineItemButton;


// WEBPACK FOOTER //
// ./src/components/orders-v3/edit-line-item-button.js